import request from '@/utils/request'

export function getMenu(data) {
  return request({
    url: 'szc_menu.yy',
    method: 'post',
    data
  })
}
